module.exports = __webpack_public_path__ + "img/section-1-m.ae53260.webp";